import knoxRaces from "../knox_candidates_seed.json";
import shelbyRaces from "../shelby_candidates_seed.json";
import davidsonRaces from "../davidson_candidates_seed.json";
import hamiltonRaces from "../hamilton_candidates_seed.json";
import countyPrimaryResults from "../county_primary_results_may_5_2026.json";
import countyElectionSources from "../tn_county_election_sources_2026.json";
import generatedCountyElections from "../generated_county_elections_2026.json";

export const GENERAL_ELECTION_DATE = "2026-08-06";
export const GENERAL_ELECTION_LABEL = "August 6, 2026";

const GOVOTE_TN_URL = "https://web.go-vote-tn.elections.tn.gov/";
const KNOX_SOURCE_URL = "https://www.knoxvotes.org/";
const SHELBY_SOURCE_URL = "https://www.electionsshelbytn.gov/upcoming-elections/";
const DAVIDSON_SOURCE_URL = "https://www.nashville.gov/departments/elections/services/find-2026-election-information";
const DAVIDSON_BALLOT_URL = "https://www.nashville.gov/sites/default/files/2026-06/Sample_Ballot_August_6_2026_State_Fed_Prim_Cty_Gen_Oak_Hill.pdf?ct=1781625299";
const DAVIDSON_CANDIDATE_LIST_URL = "https://www.nashville.gov/sites/default/files/2026-04/Candidate_List_August_6_2026_Davidson_Co_State_Federal_Primary.pdf?ct=1776447824";
const HAMILTON_SOURCE_URL = "https://elect.hamiltontn.gov/";
const HAMILTON_GENERAL_BALLOT_URL = "https://elect.hamiltontn.gov/Portals/12/HTML/GenSample.html";
const HAMILTON_REPUBLICAN_BALLOT_URL = "https://elect.hamiltontn.gov/Portals/12/HTML/RepSample.html";
const HAMILTON_DEMOCRATIC_BALLOT_URL = "https://elect.hamiltontn.gov/Portals/12/HTML/DemSample.html";
const SHELBY_GENERAL_BALLOT_URL = "https://www.electionsshelbytn.gov/wp-content/uploads/2026/07/2026-State-and-Federal-Primary-and-State-County-with-Sample-GEN-7.6.26.pdf";
const SHELBY_REPUBLICAN_BALLOT_URL = "https://www.electionsshelbytn.gov/wp-content/uploads/2026/07/2026-State-and-Federal-Primary-and-State-County-with-Sample-REP-7.6.26.pdf";
const SHELBY_DEMOCRATIC_BALLOT_URL = "https://www.electionsshelbytn.gov/wp-content/uploads/2026/07/2026-State-and-Federal-Primary-and-State-County-with-Sample-DEM-7.6.26.pdf";
const SHELBY_PRIMARY_RESULTS_URL = countyPrimaryResults.shelby.source_url;
const DAVIDSON_PRIMARY_RESULTS_URL = countyPrimaryResults.davidson.source_url;
const HAMILTON_PRIMARY_RESULTS_URL = countyPrimaryResults.hamilton.source_url;
const TN_STATE_SOURCE_URL = "https://sos.tn.gov/elections";
const CORRECTION_EMAIL = "legislature@mail.tnbills.com";
const VERIFIED_GENERATED_COUNTY_SLUGS = [
  "anderson",
  "bedford",
  "benton",
  "bledsoe",
  "blount",
  "bradley",
  "campbell",
  "cannon",
  "carroll",
  "carter",
  "cheatham",
  "chester",
  "claiborne",
  "clay",
  "cocke",
  "coffee",
  "crockett",
  "cumberland",
  "decatur",
  "dekalb",
  "dickson",
  "dyer",
  "fayette",
  "fentress",
  "franklin",
  "gibson",
  "giles",
  "grainger",
  "greene",
  "grundy",
  "hamblen",
  "hancock",
  "hardeman",
  "hardin",
  "hawkins",
  "haywood",
  "henderson",
  "henry",
  "hickman",
  "houston",
  "humphreys",
  "jackson",
  "jefferson",
  "johnson",
  "lauderdale",
  "lawrence",
  "lake",
  "lewis",
  "lincoln",
  "loudon",
  "macon",
  "madison",
  "marion",
  "marshall",
  "maury",
  "mcminn",
  "mcnairy",
  "meigs",
  "monroe",
  "moore",
  "morgan",
  "montgomery",
  "obion",
  "overton",
  "perry",
  "pickett",
  "polk",
  "putnam",
  "rhea",
  "roane",
  "robertson",
  "rutherford",
  "scott",
  "sequatchie",
  "sevier",
  "smith",
  "stewart",
  "sullivan",
  "sumner",
  "tipton",
  "trousdale",
  "union",
  "unicoi",
  "van-buren",
  "warren",
  "washington",
  "wayne",
  "weakley",
  "white",
  "williamson",
  "wilson",
];

const countyNames = [
  "Anderson",
  "Bedford",
  "Benton",
  "Bledsoe",
  "Blount",
  "Bradley",
  "Campbell",
  "Cannon",
  "Carroll",
  "Carter",
  "Cheatham",
  "Chester",
  "Claiborne",
  "Clay",
  "Cocke",
  "Coffee",
  "Crockett",
  "Cumberland",
  "Davidson",
  "Decatur",
  "DeKalb",
  "Dickson",
  "Dyer",
  "Fayette",
  "Fentress",
  "Franklin",
  "Gibson",
  "Giles",
  "Grainger",
  "Greene",
  "Grundy",
  "Hamblen",
  "Hamilton",
  "Hancock",
  "Hardeman",
  "Hardin",
  "Hawkins",
  "Haywood",
  "Henderson",
  "Henry",
  "Hickman",
  "Houston",
  "Humphreys",
  "Jackson",
  "Jefferson",
  "Johnson",
  "Knox",
  "Lake",
  "Lauderdale",
  "Lawrence",
  "Lewis",
  "Lincoln",
  "Loudon",
  "Macon",
  "Madison",
  "Marion",
  "Marshall",
  "Maury",
  "McMinn",
  "McNairy",
  "Meigs",
  "Monroe",
  "Montgomery",
  "Moore",
  "Morgan",
  "Obion",
  "Overton",
  "Perry",
  "Pickett",
  "Polk",
  "Putnam",
  "Rhea",
  "Roane",
  "Robertson",
  "Rutherford",
  "Scott",
  "Sequatchie",
  "Sevier",
  "Shelby",
  "Smith",
  "Stewart",
  "Sullivan",
  "Sumner",
  "Tipton",
  "Trousdale",
  "Unicoi",
  "Union",
  "Van Buren",
  "Warren",
  "Washington",
  "Wayne",
  "Weakley",
  "White",
  "Williamson",
  "Wilson",
];

const slugifyCounty = (name) => name.toLowerCase().replace(/\s+/g, "-");

export const TENNESSEE_COUNTIES = countyNames.map((name) => {
  const slug = slugifyCounty(name);
  const isReady = ["knox", "shelby", "davidson", "hamilton", ...VERIFIED_GENERATED_COUNTY_SLUGS]
    .includes(slug);
  const configuredSourceUrls = {
    knox: KNOX_SOURCE_URL,
    shelby: SHELBY_SOURCE_URL,
    davidson: DAVIDSON_SOURCE_URL,
    hamilton: HAMILTON_SOURCE_URL,
  };
  const countySourceUrl = configuredSourceUrls[slug]
    || countyElectionSources[slug]?.commission_url
    || GOVOTE_TN_URL;

  return {
    name: `${name} County`,
    slug,
    state: "TN",
    status: isReady ? "ready" : "shell",
    electionCommissionUrl: countySourceUrl,
    resultSourceUrl: countySourceUrl,
  };
});

const OFFICE_EXPLAINERS = {
  "county-mayor": {
    role: "The county mayor leads county government, proposes budgets, and coordinates major county services.",
    voterImpact: "This office can affect taxes, capital projects, public services, and the county's long-term priorities.",
  },
  sheriff: {
    role: "The sheriff runs the county sheriff's office, jail operations, and many law-enforcement services outside city police departments.",
    voterImpact: "This race affects public safety priorities, jail administration, and how county law enforcement is managed.",
  },
  "county-trustee": {
    role: "The trustee collects county property taxes and manages county funds that flow through the office.",
    voterImpact: "This office affects taxpayer service, collections, and transparency around public money.",
  },
  "register-of-deeds": {
    role: "The register of deeds records property deeds and other important public documents.",
    voterImpact: "This office affects real estate records, public access, and the reliability of county document systems.",
  },
};

const matcherExplainers = [
  {
    test: (race) => race.id.startsWith("county-commission") || race.id.startsWith("commission-at-large"),
    explainer: {
      role: "County commissioners vote on the county budget, local taxes, zoning-related matters, and major policy choices.",
      voterImpact: "These seats shape schools, roads, development, public safety funding, and local services.",
    },
  },
  {
    test: (race) => race.id.startsWith("board-of-education"),
    explainer: {
      role: "Board of Education members oversee the local school system, budget priorities, policies, and the superintendent relationship.",
      voterImpact: "These races affect school funding, student services, facilities, curriculum priorities, and family-facing policy.",
    },
  },
  {
    test: (race) => race.title.toLowerCase().includes("judge"),
    explainer: {
      role: "Judges preside over cases, manage courtroom process, and make decisions that affect how law is applied locally.",
      voterImpact: "Judicial races can affect case handling, courtroom access, and the day-to-day experience of the justice system.",
    },
  },
  {
    test: (race) => race.title.toLowerCase().includes("clerk"),
    explainer: {
      role: "Clerks manage court or county records, filings, fees, and customer-facing public services.",
      voterImpact: "These offices affect how easily residents can access records, file documents, and interact with local government.",
    },
  },
];

const defaultExplainer = {
  role: "This local office handles county-level decisions or services that residents interact with directly.",
  voterImpact: "The outcome can affect local services, budgets, public records, and the way county government works.",
};

const primaryExplainers = {
  governor: {
    role: "The governor leads Tennessee's executive branch, signs or vetoes bills, proposes budgets, and appoints leaders across state government.",
    voterImpact: "This race affects state spending, education, health policy, public safety priorities, and how state agencies are run.",
  },
  "us-senate": {
    role: "U.S. senators represent Tennessee in Congress, vote on federal laws, budgets, judges, treaties, and presidential appointments.",
    voterImpact: "This race affects national policy on taxes, health care, defense, courts, infrastructure, and federal funding.",
  },
  "us-house": {
    role: "U.S. representatives vote on federal laws and budgets for a specific congressional district.",
    voterImpact: "This race affects federal services, district priorities, constituent services, and national legislation.",
  },
  "tn-senate": {
    role: "Tennessee senators vote on state laws and budgets in the upper chamber of the General Assembly.",
    voterImpact: "This race affects state policy on schools, roads, taxes, courts, health care, and local-government authority.",
  },
  "tn-house": {
    role: "Tennessee representatives vote on state laws and budgets in the lower chamber of the General Assembly.",
    voterImpact: "This race affects state policy and is often the closest state-level legislative office to voters.",
  },
  "state-executive-committee": {
    role: "State executive committee members help govern party business in Tennessee, including party rules and internal leadership decisions.",
    voterImpact: "These races affect how each state party organizes, sets priorities, and conducts party business between elections.",
  },
};

const getRaceExplainer = (race) => {
  if (OFFICE_EXPLAINERS[race.id]) return OFFICE_EXPLAINERS[race.id];
  return matcherExplainers.find(({ test }) => test(race))?.explainer || defaultExplainer;
};

const getPrimaryWinner = (race, partyKey) =>
  race[partyKey].find((candidate) => candidate.primary_result === "won") || null;

const toGeneralCandidate = (candidate, countySlug = null) => {
  const primaryVotes = countySlug
    ? countyPrimaryResults[countySlug]?.candidate_votes?.[candidate.id]
    : null;

  return {
    ...candidate,
    ...(primaryVotes == null ? {} : {
      primary_votes: primaryVotes,
      primary_result: "won",
    }),
    general_votes: null,
    general_percent: null,
    general_result: "pending",
  };
};

const buildKnoxRace = (race) => {
  const republicanWinner = getPrimaryWinner(race, "republican");
  const democratWinner = getPrimaryWinner(race, "democrat");
  const republicanNominee = republicanWinner ? toGeneralCandidate(republicanWinner) : null;
  const democratNominee = democratWinner ? toGeneralCandidate(democratWinner) : null;
  const generalCandidates = [republicanNominee, democratNominee].filter(Boolean);

  return {
    ...race,
    republican: republicanNominee ? [republicanNominee] : [],
    democrat: democratNominee ? [democratNominee] : [],
    explainer: getRaceExplainer(race),
    generalElection: {
      status: "pending",
      candidates: generalCandidates,
      precinctsReporting: null,
      precinctsTotal: null,
      lastUpdated: null,
      sourceUrl: KNOX_SOURCE_URL,
      note: "General election totals will appear here after official results begin reporting.",
    },
  };
};

const buildShelbyRace = (race) => {
  const candidates = [
    ...(race.republican || []),
    ...(race.democrat || []),
    ...(race.other || []),
  ].map((candidate) => toGeneralCandidate(candidate, "shelby"));

  return {
    ...race,
    republican: (race.republican || []).map((candidate) => toGeneralCandidate(candidate, "shelby")),
    democrat: (race.democrat || []).map((candidate) => toGeneralCandidate(candidate, "shelby")),
    other: (race.other || []).map((candidate) => toGeneralCandidate(candidate, "shelby")),
    explainer: getRaceExplainer(race),
    generalElection: {
      status: "pending",
      candidates,
      precinctsReporting: null,
      precinctsTotal: null,
      lastUpdated: null,
      sourceUrl: SHELBY_GENERAL_BALLOT_URL,
      note: "General election totals will appear here after official results begin reporting.",
    },
  };
};

const buildDavidsonRace = (race) => {
  const candidates = [
    ...(race.republican || []),
    ...(race.democrat || []),
    ...(race.other || []),
  ].map((candidate) => toGeneralCandidate(candidate, "davidson"));

  return {
    ...race,
    republican: (race.republican || []).map((candidate) => toGeneralCandidate(candidate, "davidson")),
    democrat: (race.democrat || []).map((candidate) => toGeneralCandidate(candidate, "davidson")),
    other: (race.other || []).map((candidate) => toGeneralCandidate(candidate, "davidson")),
    explainer: getRaceExplainer(race),
    generalElection: {
      status: "pending",
      candidates,
      precinctsReporting: null,
      precinctsTotal: null,
      lastUpdated: null,
      sourceUrl: DAVIDSON_BALLOT_URL,
      note: "General election totals will appear here after official results begin reporting.",
    },
  };
};

const buildHamiltonRace = (race) => {
  const candidates = [
    ...(race.republican || []),
    ...(race.democrat || []),
    ...(race.other || []),
  ].map((candidate) => toGeneralCandidate(candidate, "hamilton"));

  return {
    ...race,
    republican: (race.republican || []).map((candidate) => toGeneralCandidate(candidate, "hamilton")),
    democrat: (race.democrat || []).map((candidate) => toGeneralCandidate(candidate, "hamilton")),
    other: (race.other || []).map((candidate) => toGeneralCandidate(candidate, "hamilton")),
    explainer: getRaceExplainer(race),
    generalElection: {
      status: "pending",
      candidates,
      precinctsReporting: null,
      precinctsTotal: null,
      lastUpdated: null,
      sourceUrl: HAMILTON_GENERAL_BALLOT_URL,
      note: "General election totals will appear here after official results begin reporting.",
    },
  };
};

const buildPrimaryRace = ({
  id,
  title,
  category,
  scope,
  districtNote,
  officeType = id,
  republican = [],
  democrat = [],
}) => ({
  id,
  title,
  category,
  scope,
  districtNote,
  republican,
  democrat,
  explainer: primaryExplainers[officeType] || defaultExplainer,
  primaryElection: {
    status: "pending",
    date: GENERAL_ELECTION_DATE,
    sourceUrl: TN_STATE_SOURCE_URL,
    note: "Candidate and result data can be imported from official state and county sources.",
  },
});

const KNOX_STATE_FEDERAL_PRIMARY_RACES = [
  buildPrimaryRace({
    id: "governor",
    title: "Governor",
    category: "state_primary",
    scope: "Statewide",
    districtNote: "Appears statewide on the August 6 party primary ballot.",
    republican: [
      {
        id: "governor-r-marsha-blackburn",
        name: "Marsha Blackburn",
        image_url: "/candidate_photos/marsha-blackburn-crop.jpg",
        website_url: "https://marshablackburn.com/",
      },
      {
        id: "governor-r-monty-fritts",
        name: "Monty Fritts",
        image_url: "/candidate_photos/monty-fritts.png",
        website_url: "https://fritts4tn.com/",
      },
      {
        id: "governor-r-john-rose",
        name: "John Rose",
        image_url: "/candidate_photos/john-rose-crop.png",
        website_url: "https://johnrose.com/",
      },
    ],
    democrat: [
      { id: "governor-d-carnita-atwater", name: "Carnita Atwater" },
      { id: "governor-d-tim-cyr", name: "Tim Cyr" },
      {
        id: "governor-d-jerri-green",
        name: "Jerri Green",
        image_url: "/candidate_photos/jerri-green-crop.jpg",
        website_url: "https://greenforgovernor.com/",
      },
      {
        id: "governor-d-adam-ditch-kurtz",
        name: "Adam \"Ditch\" Kurtz",
        website_url: "https://www.ditch4governor.com/",
      },
      { id: "governor-d-kevin-lee-mccants", name: "Kevin Lee McCants" },
    ],
  }),
  buildPrimaryRace({
    id: "us-senate",
    title: "U.S. Senate",
    category: "federal_primary",
    scope: "Statewide",
    districtNote: "Appears statewide on the August 6 party primary ballot.",
    republican: [
      {
        id: "us-senate-r-bill-hagerty",
        name: "Bill Hagerty",
        image_url: "/candidate_photos/bill-hagerty.jpg",
        website_url: "https://teamhagerty.com/",
      },
    ],
    democrat: [
      {
        id: "us-senate-d-marquita-bradshaw",
        name: "Marquita Bradshaw",
        image_url: "/candidate_photos/marquita-bradshaw.jpg",
        website_url: "https://www.marquitabradshaw.com/",
      },
      {
        id: "us-senate-d-maria-brewer",
        name: "Maria Brewer",
        image_url: "/candidate_photos/maria-brewer.png",
        website_url: "https://www.mariabrewerforsenate.com/",
      },
      { id: "us-senate-d-kevin-lee-mccants", name: "Kevin Lee McCants" },
      {
        id: "us-senate-d-civil-miller-watkins",
        name: "Civil Miller-Watkins",
        image_url: "/candidate_photos/civil-miller-watkins.png",
        website_url: "https://www.civil4tn.com/",
      },
      {
        id: "us-senate-d-diana-onyejiaka",
        name: "Diana Onyejiaka",
        image_url: "/candidate_photos/diana-onyejiaka.jpg",
      },
    ],
  }),
  buildPrimaryRace({
    id: "us-house-district-2",
    title: "U.S. House District 2",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Knox County voters should confirm their congressional district by address.",
    republican: [
      {
        id: "us-house-d2-r-tim-burchett",
        name: "Tim Burchett",
        image_url: "/candidate_photos/tim-burchett.jpg",
        website_url: "https://www.burchettforcongress.com/",
      },
    ],
    democrat: [
      {
        id: "us-house-d2-d-michaela-barnett",
        name: "Michaela Barnett",
        image_url: "/candidate_photos/michaela-barnett.jpg",
        website_url: "https://www.michaelafortennessee.com/",
        image_position: "50% 32%",
      },
    ],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-5",
    title: "Tennessee Senate District 5",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Knox County voter.",
    republican: [
      { id: "tn-senate-d5-r-jimmy-matlock", name: "Jimmy Matlock" },
    ],
    democrat: [
      {
        id: "tn-senate-d5-d-david-miller",
        name: "David Miller",
        image_url: "/candidate_photos/david-miller-crop.jpg",
        website_url: "https://www.davidmillerfortennessee.com/",
      },
    ],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-7",
    title: "Tennessee Senate District 7",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Knox County voter.",
    republican: [
      {
        id: "tn-senate-d7-r-richard-m-briggs",
        name: "Richard M. Briggs",
        image_url: "/candidate_photos/richard-briggs.jpg",
        website_url: "https://www.briggsforsenate.com/",
      },
      {
        id: "tn-senate-d7-r-kent-morrell",
        name: "Kent Morrell",
        image_url: "/candidate_photos/kent-morrell.jpg",
        website_url: "https://www.sendkent.com/",
      },
    ],
    democrat: [
      {
        id: "tn-senate-d7-d-bryan-langan",
        name: "Bryan Langan",
        image_url: "/candidate_photos/bryan-langan.webp",
        website_url: "https://www.langan4tn.com/",
      },
    ],
  }),
  buildPrimaryRace({
    id: "tn-house-district-14",
    title: "Tennessee House District 14",
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican: [
      {
        id: "tn-house-d14-r-jason-zachary",
        name: "Jason Zachary",
        image_url: "/candidate_photos/jason-zachary.jpg",
      },
    ],
    democrat: [
      { id: "tn-house-d14-d-lindsay-young-honaker", name: "Lindsay Young Honaker" },
      { id: "tn-house-d14-d-shivam-r-zaveri", name: "Shivam R. Zaveri" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-house-district-15",
    title: "Tennessee House District 15",
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    democrat: [
      {
        id: "tn-house-d15-d-sam-mckenzie",
        name: "Sam McKenzie",
        image_url: "/candidate_photos/sam-mckenzie.jpg",
      },
    ],
  }),
  buildPrimaryRace({
    id: "tn-house-district-16",
    title: "Tennessee House District 16",
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican: [
      {
        id: "tn-house-d16-r-michele-carringer",
        name: "Michele Carringer",
        image_url: "/candidate_photos/michele-carringer.jpg",
      },
    ],
    democrat: [
      { id: "tn-house-d16-d-eliza-boles", name: "Eliza Boles" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-house-district-18",
    title: "Tennessee House District 18",
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican: [
      {
        id: "tn-house-d18-r-elaine-davis",
        name: "Elaine Davis",
        image_url: "/candidate_photos/elaine-davis.png",
      },
      { id: "tn-house-d18-r-brent-n-jones", name: "Brent N. Jones" },
      { id: "tn-house-d18-r-elliott-schuchardt", name: "Elliott Schuchardt" },
    ],
    democrat: [
      { id: "tn-house-d18-d-bryan-goldberg", name: "Bryan Goldberg" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-house-district-19",
    title: "Tennessee House District 19",
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican: [
      {
        id: "tn-house-d19-r-dave-wright",
        name: "Dave Wright",
        image_url: "/candidate_photos/dave-wright.jpg",
      },
    ],
    democrat: [
      { id: "tn-house-d19-d-jenny-fowler", name: "Jenny Fowler" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-house-district-89",
    title: "Tennessee House District 89",
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican: [
      {
        id: "tn-house-d89-r-justin-lafferty",
        name: "Justin Lafferty",
        image_url: "/candidate_photos/justin-lafferty.jpg",
      },
    ],
    democrat: [
      { id: "tn-house-d89-d-randy-debord", name: "Randy DeBord" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-house-district-90",
    title: "Tennessee House District 90",
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    democrat: [
      {
        id: "tn-house-d90-d-gloria-johnson",
        name: "Gloria Johnson",
        image_url: "/candidate_photos/gloria-johnson.jpg",
      },
    ],
  }),
  buildPrimaryRace({
    id: "state-exec-committeeman-district-5",
    title: "State Executive Committeeman District 5",
    category: "party_primary",
    scope: "State executive committee district",
    officeType: "state-executive-committee",
    districtNote: "Appears in the party primary for voters in this executive committee district.",
    republican: [
      { id: "state-exec-cm-d5-r-zach-farrar", name: "Zach Farrar" },
      { id: "state-exec-cm-d5-r-lucas-heaton", name: "Lucas Heaton" },
    ],
    democrat: [
      { id: "state-exec-cm-d5-d-andrew-f-bennett-iii", name: "Andrew F. Bennett III" },
      { id: "state-exec-cm-d5-d-david-a-garcia", name: "David A. Garcia" },
    ],
  }),
  buildPrimaryRace({
    id: "state-exec-committeewoman-district-5",
    title: "State Executive Committeewoman District 5",
    category: "party_primary",
    scope: "State executive committee district",
    officeType: "state-executive-committee",
    districtNote: "Appears in the party primary for voters in this executive committee district.",
    republican: [
      { id: "state-exec-cw-d5-r-sherri-garrett", name: "Sherri Garrett" },
      { id: "state-exec-cw-d5-r-amy-poteet", name: "Amy Poteet" },
    ],
    democrat: [
      { id: "state-exec-cw-d5-d-anne-backus", name: "Anne Backus" },
    ],
  }),
  buildPrimaryRace({
    id: "state-exec-committeeman-district-6",
    title: "State Executive Committeeman District 6",
    category: "party_primary",
    scope: "State executive committee district",
    officeType: "state-executive-committee",
    districtNote: "Appears in the party primary for voters in this executive committee district.",
    republican: [
      { id: "state-exec-cm-d6-r-martin-ammons", name: "Martin Ammons" },
      { id: "state-exec-cm-d6-r-brian-hornback", name: "Brian Hornback" },
    ],
    democrat: [
      { id: "state-exec-cm-d6-d-jim-clement", name: "Jim Clement" },
    ],
  }),
  buildPrimaryRace({
    id: "state-exec-committeewoman-district-6",
    title: "State Executive Committeewoman District 6",
    category: "party_primary",
    scope: "State executive committee district",
    officeType: "state-executive-committee",
    districtNote: "Appears in the party primary for voters in this executive committee district.",
    republican: [
      { id: "state-exec-cw-d6-r-gwen-baxter", name: "Gwen Baxter" },
      { id: "state-exec-cw-d6-r-jane-chedester", name: "Jane Chedester" },
    ],
    democrat: [
      { id: "state-exec-cw-d6-d-amanda-collins", name: "Amanda Collins" },
    ],
  }),
  buildPrimaryRace({
    id: "state-exec-committeeman-district-7",
    title: "State Executive Committeeman District 7",
    category: "party_primary",
    scope: "State executive committee district",
    officeType: "state-executive-committee",
    districtNote: "Appears in the party primary for voters in this executive committee district.",
    republican: [
      { id: "state-exec-cm-d7-r-jeremy-coffey", name: "Jeremy Coffey" },
    ],
    democrat: [
      { id: "state-exec-cm-d7-d-will-bowen", name: "Will Bowen" },
    ],
  }),
  buildPrimaryRace({
    id: "state-exec-committeewoman-district-7",
    title: "State Executive Committeewoman District 7",
    category: "party_primary",
    scope: "State executive committee district",
    officeType: "state-executive-committee",
    districtNote: "Appears in the party primary for voters in this executive committee district.",
    republican: [
      { id: "state-exec-cw-d7-r-staci-beeler", name: "Staci Beeler" },
      { id: "state-exec-cw-d7-r-janis-c-crye", name: "Janis C. Crye" },
    ],
    democrat: [
      { id: "state-exec-cw-d7-d-dana-e-moran", name: "Dana E. Moran" },
    ],
  }),
];

const HAMILTON_STATE_FEDERAL_PRIMARY_RACES = [
  ...KNOX_STATE_FEDERAL_PRIMARY_RACES.filter((race) =>
    race.id === "governor" || race.id === "us-senate"
  ),
  buildPrimaryRace({
    id: "us-house-district-3",
    title: "U.S. House District 3",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Appears for Hamilton County voters in Tennessee's 3rd Congressional District.",
    republican: [{ id: "us-house-d3-r-chuck-fleischmann", name: "Chuck Fleischmann", image_url: "/candidate_photos/chuck-fleischmann.jpg" }],
    democrat: [
      { id: "us-house-d3-d-anna-golladay", name: "Anna Golladay" },
      { id: "us-house-d3-d-bryan-martin", name: "Bryan Martin" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-11",
    title: "Tennessee Senate District 11",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Hamilton County voter.",
    republican: [{ id: "tn-senate-d11-r-bo-watson", name: "Bo Watson", image_url: "/candidate_photos/bo-watson.png" }],
    democrat: [{ id: "tn-senate-d11-d-tim-roberts", name: "Tim Roberts" }],
  }),
  ...[
    {
      district: 26,
      republican: [{ id: "tn-house-d26-r-greg-martin", name: "Greg Martin", image_url: "/candidate_photos/greg-martin.png" }],
      democrat: [
        { id: "tn-house-d26-d-nathan-b-denton", name: "Nathan B. Denton" },
        { id: "tn-house-d26-d-lucian-lafae", name: "Lucian LaFae" },
      ],
    },
    {
      district: 27,
      republican: [
        { id: "tn-house-d27-r-tony-hullender", name: "Tony Hullender" },
        { id: "tn-house-d27-r-michele-reneau", name: "Michele Reneau", image_url: "/candidate_photos/michele-reneau.png" },
      ],
      democrat: [{ id: "tn-house-d27-d-paige-quirin", name: "Paige Quirin" }],
    },
    { district: 28, democrat: [{ id: "tn-house-d28-d-yusuf-a-hakeem", name: "Yusuf A. Hakeem", image_url: "/candidate_photos/yusuf-hakeem.png" }] },
    {
      district: 29,
      republican: [{ id: "tn-house-d29-r-greg-vital", name: "Greg Vital", image_url: "/candidate_photos/greg-vital.png" }],
      democrat: [{ id: "tn-house-d29-d-ryan-v-scofield", name: "Ryan V. Scofield" }],
    },
    {
      district: 30,
      republican: [{ id: "tn-house-d30-r-esther-helton-haynes", name: "Esther Helton Haynes", image_url: "/candidate_photos/esther-helton-haynes.png" }],
      democrat: [{ id: "tn-house-d30-d-art-rymer", name: "Art Rymer" }],
    },
  ].map(({ district, republican = [], democrat = [] }) => buildPrimaryRace({
    id: `tn-house-district-${district}`,
    title: `Tennessee House District ${district}`,
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican,
    democrat,
  })),
  ...[
    {
      district: 10,
      manRepublican: [{ id: "state-exec-cm-d10-r-kenneth-j-ken-meyer", name: "Kenneth J. (Ken) Meyer" }],
      manDemocrat: [{ id: "state-exec-cm-d10-d-chris-anderson", name: "Chris Anderson" }],
      womanRepublican: [{ id: "state-exec-cw-d10-r-emily-goldberg", name: "Emily Goldberg" }],
      womanDemocrat: [{ id: "state-exec-cw-d10-d-heather-mcclendon", name: "Heather McClendon" }],
    },
    {
      district: 11,
      manRepublican: [
        { id: "state-exec-cm-d11-r-derek-greene", name: "Derek Greene" },
        { id: "state-exec-cm-d11-r-david-g-queen", name: "David G. Queen" },
      ],
      manDemocrat: [
        { id: "state-exec-cm-d11-d-tahcere-alexander", name: "Tahcere Alexander" },
        { id: "state-exec-cm-d11-d-ryan-v-scofield", name: "Ryan V. Scofield" },
      ],
      womanRepublican: [
        { id: "state-exec-cw-d11-r-jane-armstrong", name: "Jane Armstrong" },
        { id: "state-exec-cw-d11-r-tina-j-benkiser", name: "Tina J. Benkiser" },
      ],
      womanDemocrat: [{ id: "state-exec-cw-d11-d-lisa-crowder", name: "Lisa Crowder" }],
    },
  ].flatMap(({
    district,
    manRepublican = [],
    manDemocrat = [],
    womanRepublican = [],
    womanDemocrat = [],
  }) => [
    buildPrimaryRace({
      id: `state-exec-committeeman-district-${district}`,
      title: `State Executive Committeeman District ${district}`,
      category: "party_primary",
      scope: "State executive committee district",
      officeType: "state-executive-committee",
      districtNote: "Appears in the party primary for voters in this executive committee district.",
      republican: manRepublican,
      democrat: manDemocrat,
    }),
    buildPrimaryRace({
      id: `state-exec-committeewoman-district-${district}`,
      title: `State Executive Committeewoman District ${district}`,
      category: "party_primary",
      scope: "State executive committee district",
      officeType: "state-executive-committee",
      districtNote: "Appears in the party primary for voters in this executive committee district.",
      republican: womanRepublican,
      democrat: womanDemocrat,
    }),
  ]),
];

const DAVIDSON_STATE_FEDERAL_PRIMARY_RACES = [
  ...KNOX_STATE_FEDERAL_PRIMARY_RACES.filter((race) =>
    race.id === "governor" || race.id === "us-senate"
  ),
  buildPrimaryRace({
    id: "us-house-district-4",
    title: "U.S. House District 4",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Davidson County voters should confirm their congressional district by address following the 2026 redistricting.",
    republican: [
      { id: "us-house-d4-r-thomas-e-davis", name: "Thomas E. Davis" },
      { id: "us-house-d4-r-scott-desjarlais", name: "Scott DesJarlais", image_url: "/candidate_photos/scott-desjarlais.jpg" },
      { id: "us-house-d4-r-joshua-james", name: "Joshua James" },
      { id: "us-house-d4-r-harold-rocky-jones", name: "Harold “Rocky” Jones" },
    ],
    democrat: [
      { id: "us-house-d4-d-victoria-broderick", name: "Victoria Broderick" },
      { id: "us-house-d4-d-mike-cortese", name: "Mike Cortese" },
      { id: "us-house-d4-d-cliff-huffman", name: "Cliff Huffman" },
      { id: "us-house-d4-d-tim-lanier", name: "Tim Lanier" },
      { id: "us-house-d4-d-joyce-e-neal", name: "Joyce E. Neal" },
    ],
  }),
  buildPrimaryRace({
    id: "us-house-district-6",
    title: "U.S. House District 6",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Davidson County voters should confirm their congressional district by address following the 2026 redistricting.",
    republican: [
      { id: "us-house-d6-r-natisha-brooks", name: "Natisha Brooks" },
      { id: "us-house-d6-r-johnny-garrett", name: "Johnny Garrett", image_url: "/candidate_photos/johnny-garrett.png" },
      { id: "us-house-d6-r-jon-henry", name: "Jon Henry" },
      { id: "us-house-d6-r-van-hilleary", name: "Van Hilleary" },
    ],
    democrat: [
      { id: "us-house-d6-d-lore-bergman", name: "Lore Bergman" },
      { id: "us-house-d6-d-mike-croley", name: "Mike Croley" },
      { id: "us-house-d6-d-christopher-martin-finley", name: "Christopher Martin Finley" },
      { id: "us-house-d6-d-miriam-leibowitz", name: "Miriam Leibowitz" },
      { id: "us-house-d6-d-chaney-mosley", name: "Chaney Mosley" },
    ],
  }),
  buildPrimaryRace({
    id: "us-house-district-7",
    title: "U.S. House District 7",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Davidson County voters should confirm their congressional district by address following the 2026 redistricting.",
    republican: [{ id: "us-house-d7-r-matt-van-epps", name: "Matt Van Epps", image_url: "/candidate_photos/matt-van-epps.webp" }],
    democrat: [
      { id: "us-house-d7-d-darden-copeland", name: "Darden Copeland" },
      { id: "us-house-d7-d-vincent-dixie", name: "Vincent Dixie" },
      { id: "us-house-d7-d-saletta-holloway", name: "Saletta Holloway" },
      { id: "us-house-d7-d-joshua-warren-sales", name: "Joshua Warren Sales" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-17",
    title: "Tennessee Senate District 17",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Davidson County voter.",
    republican: [
      { id: "tn-senate-d17-r-theodore-butch-baker", name: "Theodore (Butch) Baker" },
      { id: "tn-senate-d17-r-mark-pody", name: "Mark Pody", image_url: "/candidate_photos/mark-pody.png" },
    ],
    democrat: [
      { id: "tn-senate-d17-d-joni-cochran", name: "Joni Cochran" },
      { id: "tn-senate-d17-d-lindsey-patrick-wright", name: "Lindsey Patrick-Wright" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-19",
    title: "Tennessee Senate District 19",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Davidson County voter.",
    democrat: [{ id: "tn-senate-d19-d-charlane-oliver", name: "Charlane Oliver", image_url: "/candidate_photos/charlane-oliver.png" }],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-21",
    title: "Tennessee Senate District 21",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Davidson County voter.",
    democrat: [{ id: "tn-senate-d21-d-jeff-yarbro", name: "Jeff Yarbro", image_url: "/candidate_photos/jeff-yarbro.png" }],
  }),
  ...[
    { district: 50, democrat: [{ id: "tn-house-d50-d-bo-mitchell", name: "Bo Mitchell", image_url: "/candidate_photos/bo-mitchell.png" }] },
    { district: 51, democrat: [{ id: "tn-house-d51-d-aftyn-behn", name: "Aftyn Behn", image_url: "/candidate_photos/aftyn-behn.png" }] },
    {
      district: 52,
      republican: [{ id: "tn-house-d52-r-michele-vetter", name: "Michele Vetter" }],
      democrat: [{ id: "tn-house-d52-d-justin-jones", name: "Justin Jones", image_url: "/candidate_photos/justin-jones.png" }],
    },
    { district: 53, democrat: [{ id: "tn-house-d53-d-jason-l-powell", name: "Jason L. Powell", image_url: "/candidate_photos/jason-powell.png" }] },
    { district: 54, democrat: [{ id: "tn-house-d54-d-vincent-dixie", name: "Vincent Dixie", image_url: "/candidate_photos/vincent-dixie.png" }] },
    {
      district: 55,
      republican: [{ id: "tn-house-d55-r-jayla-thomas", name: "Jayla Thomas" }],
      democrat: [{ id: "tn-house-d55-d-john-ray-clemmons", name: "John Ray Clemmons", image_url: "/candidate_photos/john-ray-clemmons.png" }],
    },
    { district: 56, democrat: [{ id: "tn-house-d56-d-bob-freeman", name: "Bob Freeman", image_url: "/candidate_photos/bob-freeman.png" }] },
    { district: 58, democrat: [{ id: "tn-house-d58-d-harold-m-love-jr", name: "Harold M. Love, Jr.", image_url: "/candidate_photos/harold-love.png" }] },
    {
      district: 59,
      republican: [{ id: "tn-house-d59-r-bill-hancock", name: "Bill Hancock" }],
      democrat: [
        { id: "tn-house-d59-d-rick-ewing", name: "Rick Ewing" },
        { id: "tn-house-d59-d-angie-lawless", name: "Angie Lawless" },
        { id: "tn-house-d59-d-mark-proctor", name: "Mark Proctor" },
        { id: "tn-house-d59-d-beth-west", name: "Beth West" },
      ],
    },
    {
      district: 60,
      republican: [{ id: "tn-house-d60-r-eva-angelina-romero", name: "Eva Angelina Romero" }],
      democrat: [{ id: "tn-house-d60-d-shaundelle-brooks", name: "Shaundelle Brooks", image_url: "/candidate_photos/shaundelle-brooks.png" }],
    },
  ].map(({ district, republican = [], democrat = [] }) => buildPrimaryRace({
    id: `tn-house-district-${district}`,
    title: `Tennessee House District ${district}`,
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican,
    democrat,
  })),
  ...[
    {
      district: 17,
      manRepublican: [
        { id: "state-exec-cm-d17-r-brad-lytle", name: "Brad Lytle" },
        { id: "state-exec-cm-d17-r-derek-truelove", name: "Derek Truelove" },
      ],
      manDemocrat: [{ id: "state-exec-cm-d17-d-richie-mercado", name: "Richie Mercado" }],
      womanRepublican: [{ id: "state-exec-cw-d17-r-terri-r-nicholson", name: "Terri R. Nicholson" }],
      womanDemocrat: [
        { id: "state-exec-cw-d17-d-melissa-alvarez", name: "Melissa Alvarez" },
        { id: "state-exec-cw-d17-d-brittany-orpurt-hilton", name: "Brittany Orpurt-Hilton" },
      ],
    },
    {
      district: 19,
      manRepublican: [{ id: "state-exec-cm-d19-r-steve-brubaker", name: "Steve Brubaker" }],
      manDemocrat: [
        { id: "state-exec-cm-d19-d-jonathan-saad", name: "Jonathan Saad" },
        { id: "state-exec-cm-d19-d-josh-wesley", name: "Josh Wesley" },
      ],
      womanDemocrat: [{ id: "state-exec-cw-d19-d-marcia-masulla", name: "Marcia Masulla" }],
    },
    {
      district: 20,
      manRepublican: [{ id: "state-exec-cm-d20-r-ronald-mcdow", name: "Ronald McDow" }],
      manDemocrat: [{ id: "state-exec-cm-d20-d-tyler-brasher", name: "Tyler Brasher" }],
      womanRepublican: [
        { id: "state-exec-cw-d20-r-lulu-elam", name: "Lulu Elam" },
        { id: "state-exec-cw-d20-r-annalisa-z-young", name: "Annalisa Z. Young" },
      ],
      womanDemocrat: [{ id: "state-exec-cw-d20-d-lee-jones", name: "Lee Jones" }],
    },
    {
      district: 21,
      manDemocrat: [
        { id: "state-exec-cm-d21-d-dakota-galban", name: "Dakota Galban" },
        { id: "state-exec-cm-d21-d-john-summers", name: "John Summers" },
      ],
      womanRepublican: [{ id: "state-exec-cw-d21-r-larawn-scaife", name: "Larawn Scaife" }],
    },
  ].flatMap(({
    district,
    manRepublican = [],
    manDemocrat = [],
    womanRepublican = [],
    womanDemocrat = [],
  }) => [
    buildPrimaryRace({
      id: `state-exec-committeeman-district-${district}`,
      title: `State Executive Committeeman District ${district}`,
      category: "party_primary",
      scope: "State executive committee district",
      officeType: "state-executive-committee",
      districtNote: "Appears in the party primary for voters in this executive committee district.",
      republican: manRepublican,
      democrat: manDemocrat,
    }),
    buildPrimaryRace({
      id: `state-exec-committeewoman-district-${district}`,
      title: `State Executive Committeewoman District ${district}`,
      category: "party_primary",
      scope: "State executive committee district",
      officeType: "state-executive-committee",
      districtNote: "Appears in the party primary for voters in this executive committee district.",
      republican: womanRepublican,
      democrat: womanDemocrat,
    }),
  ]),
];

const SHELBY_STATE_FEDERAL_PRIMARY_RACES = [
  ...KNOX_STATE_FEDERAL_PRIMARY_RACES.filter((race) =>
    race.id === "governor" || race.id === "us-senate"
  ),
  buildPrimaryRace({
    id: "us-house-district-5",
    title: "U.S. House District 5",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Shelby County voters should confirm their congressional district by address.",
    republican: [
      { id: "us-house-d5-r-charlie-hatcher", name: "Charlie Hatcher" },
      { id: "us-house-d5-r-andy-ogles", name: "Andy Ogles" },
    ],
    democrat: [
      { id: "us-house-d5-d-yolanda-cooper-sutton", name: "Yolanda Cooper-Sutton" },
      { id: "us-house-d5-d-devante-r-hill", name: "DeVante R. Hill" },
      { id: "us-house-d5-d-rachel-hurley", name: "Rachel Hurley" },
      { id: "us-house-d5-d-carrie-ann-iacomini", name: "Carrie Ann Iacomini" },
      { id: "us-house-d5-d-chaz-molder", name: "Chaz Molder" },
    ],
  }),
  buildPrimaryRace({
    id: "us-house-district-8",
    title: "U.S. House District 8",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Shelby County voters should confirm their congressional district by address.",
    republican: [
      { id: "us-house-d8-r-david-kustoff", name: "David Kustoff" },
    ],
    democrat: [
      { id: "us-house-d8-d-dewey-gordon-bryan", name: "Dewey Gordon Bryan" },
      { id: "us-house-d8-d-jordan-d-hinders", name: "Jordan D. Hinders" },
      { id: "us-house-d8-d-heidi-kuhn", name: "Heidi Kuhn" },
      { id: "us-house-d8-d-leonard-perkins", name: "Leonard Perkins" },
    ],
  }),
  buildPrimaryRace({
    id: "us-house-district-9",
    title: "U.S. House District 9",
    category: "federal_primary",
    scope: "Congressional district",
    officeType: "us-house",
    districtNote: "Shelby County voters should confirm their congressional district by address.",
    republican: [
      { id: "us-house-d9-r-charlotte-bergmann", name: "Charlotte Bergmann" },
      { id: "us-house-d9-r-brent-taylor", name: "Brent Taylor", image_url: "/candidate_photos/brent-taylor.jpg" },
      { id: "us-house-d9-r-jeremy-thompson", name: "Jeremy Thompson" },
      { id: "us-house-d9-r-todd-warner", name: "Todd Warner" },
    ],
    democrat: [
      { id: "us-house-d9-d-m-latroy-a-williams", name: "M. LaTroy A-Williams" },
      { id: "us-house-d9-d-london-lamar", name: "London Lamar", image_url: "/candidate_photos/london-lamar.jpg" },
      { id: "us-house-d9-d-justin-j-pearson", name: "Justin J. Pearson", image_url: "/candidate_photos/justin-pearson.jpg" },
      { id: "us-house-d9-d-jim-torino", name: "Jim Torino" },
    ],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-29",
    title: "Tennessee Senate District 29",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Shelby County voter.",
    democrat: [{ id: "tn-senate-d29-d-raumesh-akbari", name: "Raumesh Akbari", image_url: "/candidate_photos/raumesh-akbari.jpg" }],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-31",
    title: "Tennessee Senate District 31",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Shelby County voter.",
    republican: [{ id: "tn-senate-d31-r-brent-taylor", name: "Brent Taylor", image_url: "/candidate_photos/brent-taylor.jpg" }],
    democrat: [{ id: "tn-senate-d31-d-david-weatherspoon", name: "David Weatherspoon" }],
  }),
  buildPrimaryRace({
    id: "tn-senate-district-33",
    title: "Tennessee Senate District 33",
    category: "state_primary",
    scope: "State Senate district",
    officeType: "tn-senate",
    districtNote: "State Senate contests vary by district and may not appear for every Shelby County voter.",
    democrat: [
      { id: "tn-senate-d33-d-tamika-l-abrum", name: "Tamika L. Abrum" },
      { id: "tn-senate-d33-d-london-lamar", name: "London Lamar", image_url: "/candidate_photos/london-lamar.jpg" },
    ],
  }),
  ...[
    {
      district: 83,
      republican: [{ id: "tn-house-d83-r-mark-white", name: "Mark White", image_url: "/candidate_photos/mark-white.jpg" }],
      democrat: [{ id: "tn-house-d83-d-margaret-price", name: "Margaret Price" }],
    },
    {
      district: 84,
      democrat: [
        { id: "tn-house-d84-d-kyler-l-gilkey", name: "Kyler L. Gilkey" },
        { id: "tn-house-d84-d-joe-towns-jr", name: "Joe Towns Jr.", image_url: "/candidate_photos/joe-towns.jpg" },
      ],
    },
    { district: 85, democrat: [{ id: "tn-house-d85-d-jesse-chism", name: "Jesse Chism", image_url: "/candidate_photos/jesse-chism.jpg" }] },
    {
      district: 86,
      democrat: [
        { id: "tn-house-d86-d-david-page", name: "David Page" },
        { id: "tn-house-d86-d-justin-j-pearson", name: "Justin J. Pearson", image_url: "/candidate_photos/justin-pearson.jpg" },
      ],
    },
    {
      district: 87,
      republican: [{ id: "tn-house-d87-r-reggie-william-hall", name: "Reggie William Hall" }],
      democrat: [{ id: "tn-house-d87-d-karen-camper", name: "Karen Camper", image_url: "/candidate_photos/karen-camper.jpg" }],
    },
    { district: 88, democrat: [{ id: "tn-house-d88-d-larry-j-miller", name: "Larry J. Miller", image_url: "/candidate_photos/larry-miller.jpg" }] },
    {
      district: 91,
      democrat: [
        { id: "tn-house-d91-d-arriell-gipson-martin", name: "Arriell Gipson-Martin" },
        { id: "tn-house-d91-d-torrey-c-harris", name: "Torrey C. Harris", image_url: "/candidate_photos/torrey-harris.jpg" },
      ],
    },
    { district: 93 },
    { district: 95, republican: [{ id: "tn-house-d95-r-kevin-vaughan", name: "Kevin Vaughan", image_url: "/candidate_photos/kevin-vaughan.jpg" }] },
    {
      district: 96,
      democrat: [
        { id: "tn-house-d96-d-telisa-franklin", name: "Telisa Franklin" },
        { id: "tn-house-d96-d-gabby-salinas", name: "Gabby Salinas" },
      ],
    },
    {
      district: 97,
      republican: [{ id: "tn-house-d97-r-john-gillespie", name: "John Gillespie", image_url: "/candidate_photos/john-gillespie.jpg" }],
      democrat: [{ id: "tn-house-d97-d-jesse-huseth", name: "Jesse Huseth" }],
    },
    { district: 98, democrat: [{ id: "tn-house-d98-d-antonio-parkinson", name: "Antonio Parkinson", image_url: "/candidate_photos/antonio-parkinson.jpg" }] },
    {
      district: 99,
      republican: [
        { id: "tn-house-d99-r-tom-leatherwood", name: "Tom Leatherwood", image_url: "/candidate_photos/tom-leatherwood.jpg" },
        { id: "tn-house-d99-r-amber-mills", name: "Amber Mills" },
      ],
    },
  ].map(({ district, republican = [], democrat = [] }) => buildPrimaryRace({
    id: `tn-house-district-${district}`,
    title: `Tennessee House District ${district}`,
    category: "state_primary",
    scope: "State House district",
    officeType: "tn-house",
    districtNote: "State House contests vary by district and should be matched to each voter's address.",
    republican,
    democrat,
  })),
  ...[
    {
      district: 29,
      manRepublican: [{ id: "state-exec-cm-d29-r-terry-roland", name: "Terry Roland" }],
      manDemocrat: [{ id: "state-exec-cm-d29-d-darrick-harris", name: "Darrick Harris" }],
      womanRepublican: [{ id: "state-exec-cw-d29-r-melanie-mosley", name: "Melanie Mosley" }],
      womanDemocrat: [
        { id: "state-exec-cw-d29-d-allison-brownlee", name: "Allison Brownlee" },
        { id: "state-exec-cw-d29-d-tyra-turner-cleasant", name: "Tyra Turner-Cleasant" },
      ],
    },
    {
      district: 30,
      manRepublican: [{ id: "state-exec-cm-d30-r-timothy-alan-beacham", name: "Timothy Alan (Tim) Beacham" }],
      manDemocrat: [{ id: "state-exec-cm-d30-d-allan-h-creasy", name: "Allan H. Creasy" }],
      womanDemocrat: [
        { id: "state-exec-cw-d30-d-jasmine-boyd-wilson", name: "Jasmine Boyd-Wilson" },
        { id: "state-exec-cw-d30-d-natoria-carpenter", name: "Natoria Carpenter" },
        { id: "state-exec-cw-d30-d-verlie-a-horton", name: "Verlie A. Horton" },
      ],
    },
    {
      district: 31,
      manRepublican: [{ id: "state-exec-cm-d31-r-randy-hendon", name: "Randy Hendon" }],
      manDemocrat: [{ id: "state-exec-cm-d31-d-david-holt", name: "David Holt" }],
      womanRepublican: [{ id: "state-exec-cw-d31-r-peggy-c-larkin", name: "Peggy C. Larkin" }],
      womanDemocrat: [{ id: "state-exec-cw-d31-d-rosemary-winters", name: "Rosemary Winters" }],
    },
    {
      district: 32,
      manRepublican: [{ id: "state-exec-cm-d32-r-lee-mills", name: "Lee Mills" }],
      manDemocrat: [{ id: "state-exec-cm-d32-d-gregory-w-patrick", name: "Gregory W. Patrick" }],
      womanRepublican: [{ id: "state-exec-cw-d32-r-charlotte-kelley", name: "Charlotte Kelley" }],
      womanDemocrat: [
        { id: "state-exec-cw-d32-d-georgia-m-dawson", name: "Georgia M. Dawson" },
        { id: "state-exec-cw-d32-d-regina-nash", name: "Regina Nash" },
      ],
    },
    {
      district: 33,
      manRepublican: [{ id: "state-exec-cm-d33-r-dewayne-jackson", name: "Dewayne Jackson" }],
      manDemocrat: [{ id: "state-exec-cm-d33-d-jonathan-carroll", name: "Jonathan Carroll" }],
      womanDemocrat: [{ id: "state-exec-cw-d33-d-adrienne-davis", name: "Adrienne Davis" }],
    },
  ].flatMap(({
    district,
    manRepublican = [],
    manDemocrat = [],
    womanRepublican = [],
    womanDemocrat = [],
  }) => [
    buildPrimaryRace({
      id: `state-exec-committeeman-district-${district}`,
      title: `State Executive Committeeman District ${district}`,
      category: "party_primary",
      scope: "State executive committee district",
      officeType: "state-executive-committee",
      districtNote: "Appears in the party primary for voters in this executive committee district.",
      republican: manRepublican,
      democrat: manDemocrat,
    }),
    buildPrimaryRace({
      id: `state-exec-committeewoman-district-${district}`,
      title: `State Executive Committeewoman District ${district}`,
      category: "party_primary",
      scope: "State executive committee district",
      officeType: "state-executive-committee",
      districtNote: "Appears in the party primary for voters in this executive committee district.",
      republican: womanRepublican,
      democrat: womanDemocrat,
    }),
  ]),
];

export const KNOX_AUGUST_6_2026 = {
  countySlug: "knox",
  countyName: "Knox County",
  state: "TN",
  title: "Knox County August 6, 2026 Election Hub",
  electionDate: GENERAL_ELECTION_DATE,
  electionLabel: GENERAL_ELECTION_LABEL,
  status: "pre_election",
  resultsStatusLabel: "Results pending",
  sourceLabel: "Knox County Election Commission",
  sourceUrl: KNOX_SOURCE_URL,
  voterInfoUrl: GOVOTE_TN_URL,
  correctionEmail: CORRECTION_EMAIL,
  lastUpdated: "2026-07-07",
  precinctsReporting: null,
  precinctsTotal: null,
  keyDates: [
    {
      label: "Now",
      title: "Candidate guide is live",
      detail: "Primary winners, campaign links, finance links, and office explainers are ready for voters.",
    },
    {
      label: "Aug 6",
      title: "Election day",
      detail: "Use this page as the election-night results view once official totals begin reporting.",
    },
    {
      label: "After canvass",
      title: "Certified archive",
      detail: "Replace live snapshots with certified totals and keep this page as a permanent record.",
    },
  ],
  sourceLinks: [
    { label: "Official county source", url: KNOX_SOURCE_URL },
    { label: "GoVoteTN voter lookup", url: GOVOTE_TN_URL },
    { label: "Campaign finance filings", url: "https://knoxcountytn.easyvotecampaignfinance.com/home/publicfilings" },
    { label: "WhoFundsTN finance data", url: "https://whofundstn.org/data/" },
  ],
  primaryRaces: KNOX_STATE_FEDERAL_PRIMARY_RACES,
  races: knoxRaces.map(buildKnoxRace),
};

export const SHELBY_AUGUST_6_2026 = {
  countySlug: "shelby",
  countyName: "Shelby County",
  state: "TN",
  title: "Memphis & Shelby County August 6, 2026 Election Hub",
  electionDate: GENERAL_ELECTION_DATE,
  electionLabel: GENERAL_ELECTION_LABEL,
  status: "pre_election",
  resultsStatusLabel: "Results pending",
  sourceLabel: "Shelby County Election Commission",
  sourceUrl: SHELBY_SOURCE_URL,
  voterInfoUrl: GOVOTE_TN_URL,
  correctionEmail: CORRECTION_EMAIL,
  lastUpdated: "2026-07-11",
  precinctsReporting: null,
  precinctsTotal: null,
  keyDates: [
    {
      label: "Jul 17",
      title: "Early voting begins",
      detail: "Early voting runs from July 17 through August 1 at Shelby County locations.",
    },
    {
      label: "Aug 6",
      title: "Election day",
      detail: "Use this page as the election-night results view once official totals begin reporting.",
    },
    {
      label: "After canvass",
      title: "Certified archive",
      detail: "Replace live snapshots with certified totals and keep this page as a permanent record.",
    },
  ],
  sourceLinks: [
    { label: "Shelby election hub", url: SHELBY_SOURCE_URL },
    { label: "May 5 county-primary results (final unofficial)", url: SHELBY_PRIMARY_RESULTS_URL },
    { label: "County general sample ballot", url: SHELBY_GENERAL_BALLOT_URL },
    { label: "Republican primary ballot", url: SHELBY_REPUBLICAN_BALLOT_URL },
    { label: "Democratic primary ballot", url: SHELBY_DEMOCRATIC_BALLOT_URL },
    { label: "GoVoteTN voter lookup", url: GOVOTE_TN_URL },
  ],
  primaryRaces: SHELBY_STATE_FEDERAL_PRIMARY_RACES,
  races: shelbyRaces.map(buildShelbyRace),
};

export const DAVIDSON_AUGUST_6_2026 = {
  countySlug: "davidson",
  countyName: "Davidson County",
  state: "TN",
  title: "Nashville & Davidson County August 6, 2026 Election Hub",
  electionDate: GENERAL_ELECTION_DATE,
  electionLabel: GENERAL_ELECTION_LABEL,
  status: "pre_election",
  resultsStatusLabel: "Results pending",
  sourceLabel: "Davidson County Election Commission",
  sourceUrl: DAVIDSON_SOURCE_URL,
  voterInfoUrl: GOVOTE_TN_URL,
  correctionEmail: CORRECTION_EMAIL,
  lastUpdated: "2026-07-11",
  precinctsReporting: null,
  precinctsTotal: null,
  keyDates: [
    {
      label: "Jul 17",
      title: "Early voting begins",
      detail: "Early voting runs from July 17 through August 1 at Davidson County locations.",
    },
    {
      label: "Aug 6",
      title: "Election day",
      detail: "Use this page as the election-night results view once official totals begin reporting.",
    },
    {
      label: "After canvass",
      title: "Certified archive",
      detail: "Replace live snapshots with certified totals and keep this page as a permanent record.",
    },
  ],
  sourceLinks: [
    { label: "Davidson election hub", url: DAVIDSON_SOURCE_URL },
    { label: "Certified May 5 county-primary results", url: DAVIDSON_PRIMARY_RESULTS_URL },
    { label: "Official sample ballot", url: DAVIDSON_BALLOT_URL },
    { label: "State and federal candidate list", url: DAVIDSON_CANDIDATE_LIST_URL },
    { label: "GoVoteTN voter lookup", url: GOVOTE_TN_URL },
  ],
  primaryRaces: DAVIDSON_STATE_FEDERAL_PRIMARY_RACES,
  races: davidsonRaces.map(buildDavidsonRace),
};

export const HAMILTON_AUGUST_6_2026 = {
  countySlug: "hamilton",
  countyName: "Hamilton County",
  state: "TN",
  title: "Chattanooga & Hamilton County August 6, 2026 Election Hub",
  electionDate: GENERAL_ELECTION_DATE,
  electionLabel: GENERAL_ELECTION_LABEL,
  status: "pre_election",
  resultsStatusLabel: "Results pending",
  sourceLabel: "Hamilton County Election Commission",
  sourceUrl: HAMILTON_SOURCE_URL,
  voterInfoUrl: GOVOTE_TN_URL,
  correctionEmail: CORRECTION_EMAIL,
  lastUpdated: "2026-07-12",
  precinctsReporting: null,
  precinctsTotal: null,
  keyDates: [
    {
      label: "Jul 17",
      title: "Early voting begins",
      detail: "Early voting runs from July 17 through August 1 at Hamilton County locations.",
    },
    {
      label: "Aug 6",
      title: "Election day",
      detail: "Use this page as the election-night results view once official totals begin reporting.",
    },
    {
      label: "After canvass",
      title: "Certified archive",
      detail: "Replace live snapshots with certified totals and keep this page as a permanent record.",
    },
  ],
  sourceLinks: [
    { label: "Hamilton election hub", url: HAMILTON_SOURCE_URL },
    { label: "May 5 county-primary results (final unofficial)", url: HAMILTON_PRIMARY_RESULTS_URL },
    { label: "County general sample ballot", url: HAMILTON_GENERAL_BALLOT_URL },
    { label: "Republican primary ballot", url: HAMILTON_REPUBLICAN_BALLOT_URL },
    { label: "Democratic primary ballot", url: HAMILTON_DEMOCRATIC_BALLOT_URL },
    { label: "GoVoteTN voter lookup", url: GOVOTE_TN_URL },
  ],
  primaryRaces: HAMILTON_STATE_FEDERAL_PRIMARY_RACES,
  races: hamiltonRaces.map(buildHamiltonRace),
};

const normalizeCandidateName = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "");
const knownPrimaryCandidateProfiles = new Map();
[
  ...KNOX_STATE_FEDERAL_PRIMARY_RACES,
  ...SHELBY_STATE_FEDERAL_PRIMARY_RACES,
  ...DAVIDSON_STATE_FEDERAL_PRIMARY_RACES,
  ...HAMILTON_STATE_FEDERAL_PRIMARY_RACES,
].forEach((race) => {
  [...(race.republican || []), ...(race.democrat || [])].forEach((candidate) => {
    const key = normalizeCandidateName(candidate.name);
    const existing = knownPrimaryCandidateProfiles.get(key) || {};
    knownPrimaryCandidateProfiles.set(key, { ...existing, ...candidate });
  });
});

const enrichKnownPrimaryCandidate = (candidate) => {
  const profile = knownPrimaryCandidateProfiles.get(normalizeCandidateName(candidate.name)) || {};
  return {
    ...candidate,
    ...profile,
    id: candidate.id,
  };
};

const getGeneratedPrimaryOfficeType = (raceId) => {
  if (raceId.startsWith("us-house")) return "us-house";
  if (raceId.startsWith("us-senate")) return "us-senate";
  if (raceId.startsWith("tn-house")) return "tn-house";
  if (raceId.startsWith("tn-senate")) return "tn-senate";
  if (raceId.startsWith("state-executive")) return "state-executive-committee";
  return raceId;
};

const buildGeneratedPrimaryRace = (race) => buildPrimaryRace({
  ...race,
  category: race.id.startsWith("us-")
    ? "federal_primary"
    : race.id.startsWith("state-executive")
      ? "party_primary"
      : "state_primary",
  officeType: getGeneratedPrimaryOfficeType(race.id),
  republican: (race.republican || []).map(enrichKnownPrimaryCandidate),
  democrat: (race.democrat || []).map(enrichKnownPrimaryCandidate),
});

const buildGeneratedGeneralRace = (race, countySlug, sourceUrl) => {
  const republican = (race.republican || []).map((candidate) => toGeneralCandidate(candidate, countySlug));
  const democrat = (race.democrat || []).map((candidate) => toGeneralCandidate(candidate, countySlug));
  const other = (race.other || []).map((candidate) => toGeneralCandidate(candidate, countySlug));

  return {
    ...race,
    republican,
    democrat,
    other,
    explainer: getRaceExplainer(race),
    generalElection: {
      status: "pending",
      candidates: [...republican, ...democrat, ...other],
      precinctsReporting: null,
      precinctsTotal: null,
      lastUpdated: null,
      sourceUrl,
      note: "General election totals will appear here after official results begin reporting.",
    },
  };
};

const buildGeneratedCountyElection = (entry) => ({
  countySlug: entry.countySlug,
  countyName: entry.countyName,
  state: "TN",
  title: `${entry.countyName} August 6, 2026 Election Hub`,
  electionDate: GENERAL_ELECTION_DATE,
  electionLabel: GENERAL_ELECTION_LABEL,
  status: "pre_election",
  resultsStatusLabel: "Results pending",
  sourceLabel: `${entry.countyName} Election Commission`,
  sourceUrl: entry.sourceUrl,
  voterInfoUrl: GOVOTE_TN_URL,
  correctionEmail: CORRECTION_EMAIL,
  lastUpdated: "2026-07-12",
  precinctsReporting: null,
  precinctsTotal: null,
  keyDates: [
    {
      label: "Jul 17",
      title: "Early voting begins",
      detail: `Early voting runs from July 17 through August 1 at ${entry.countyName} locations.`,
    },
    {
      label: "Aug 6",
      title: "Election day",
      detail: "Use this page as the election-night results view once official totals begin reporting.",
    },
    {
      label: "After canvass",
      title: "Certified archive",
      detail: "Replace live snapshots with certified totals and keep this page as a permanent record.",
    },
  ],
  sourceLinks: [
    ...(entry.sourceLinks || []),
    { label: "GoVoteTN voter lookup", url: GOVOTE_TN_URL },
  ],
  primaryRaces: (entry.primaryRaces || []).map(buildGeneratedPrimaryRace),
  races: (entry.races || []).map((race) => buildGeneratedGeneralRace(
    race,
    entry.countySlug,
    entry.sourceUrl,
  )),
});

const VERIFIED_GENERATED_COUNTY_ELECTIONS = Object.fromEntries(
  VERIFIED_GENERATED_COUNTY_SLUGS.map((slug) => [
    slug,
    buildGeneratedCountyElection(generatedCountyElections[slug]),
  ]),
);

export const COUNTY_ELECTIONS = {
  knox: KNOX_AUGUST_6_2026,
  shelby: SHELBY_AUGUST_6_2026,
  davidson: DAVIDSON_AUGUST_6_2026,
  hamilton: HAMILTON_AUGUST_6_2026,
  ...VERIFIED_GENERATED_COUNTY_ELECTIONS,
};

export const getCounty = (slug) =>
  TENNESSEE_COUNTIES.find((county) => county.slug === slug) || null;

export const getCountyElection = (slug) => COUNTY_ELECTIONS[slug] || null;

export const getConfiguredCountyCount = () => Object.keys(COUNTY_ELECTIONS).length;
